import { Colors } from '@oy/uicore';
import { Text } from '@oy/uidesktop';
import { useDomainEnv } from 'src/hooks';
import { BrandSwitcherDev } from '../BrandSwitcherDev/BrandSwitcherDev';
import styles from './DevConfigBanner.module.css';
import { useDevConfigBannerImpl } from './useDevConfigBannerImpl';

export const DevConfigBanner = () => {
  const { onClickNext, state } = useDevConfigBannerImpl();
  const { isDomainProdEnv } = useDomainEnv();
  const { data } = state;

  if (isDomainProdEnv) return null;
  return (
    <div className={styles.container}>
      <Text
        textStyle={Text.Style.BodyMdSemibold}
        tag="span"
        onClick={onClickNext}
        color={Colors.WHITE}
        className={styles.devMode}
      >
        {data?.label ?? 'Dev'}
      </Text>
      <BrandSwitcherDev />
    </div>
  );
};
